<template>
  <div class="app">
    <div class="stage">
      <div class="stage__padding">
        <div class="stage__inner">
          <button
            class="scene__nav scene__nav--previous button"
            v-if="currentScene > 1"
            @click="previousScene()"
          >
            <span class="scene__nav-inner">Back</span>
          </button>
          <button
            class="scene__nav scene__nav--next button"
            @click="nextScene()"
            v-if="!beginButton"
          >
            <span class="scene__nav-inner">{{ nextButtonText }}</span>
          </button>
          <button
            class="mute"
            :class="{
              'muted': muted
            }"
            @click="toggleMute()"
          >toggle mute</button>
          <button
            class="scene__begin button"
            @click="begin()"
            v-if="beginButton"
          >Begin</button>
          <div
            class="scene__prevent-nav"
            v-if="currentScene === 5 && (verseA === '' || verseB === '')"
          ></div>
          <div
            class="scene scene-1"
            :class="{
              'active': currentScene === 1
            }"
          >
            <div class="scene-1__lightning"></div>
            <Raindrop class="raindrop-1"></Raindrop>
            <Raindrop class="raindrop-2"></Raindrop>
            <Raindrop class="raindrop-3"></Raindrop>
            <Raindrop class="raindrop-4"></Raindrop>
            <Raindrop class="raindrop-5"></Raindrop>
            <Raindrop class="raindrop-6"></Raindrop>
            <Raindrop class="raindrop-7"></Raindrop>
            <Raindrop class="raindrop-8"></Raindrop>
            <Raindrop class="raindrop-9"></Raindrop>
            <Raindrop class="raindrop-10"></Raindrop>
            <div class="scene-1__cloud"></div>
            <h1 class="scene-1__heading">
              <span class="scene-1__heading-text">Got the Blues</span>
            </h1>
            <Leroy></Leroy>
          </div>
          <div
            class="scene scene-2"
            :class="{
              'active': currentScene === 2
            }"
          >
            <div class="scene__background"></div>
            <div class="scene-2__text">
              <p>You got the blues. I tell you the blues are sad songs some folks say. They are songs that the enslaved folks sang to express their frustrations. The blues songs can be about all your bad feelings. Like if you lost someone you love.</p>
              <p>The blues is like medicine music. It's music really sung for the singer. It is not necessary that you have an audience to sing these songs.</p>
            </div>
            <Leroy :tear="true"></Leroy>
          </div>
          <div
            class="scene scene-3"
            :class="{
              'active': currentScene === 3
            }"
          >
            <div class="scene__background"></div>
            <div class="scene__content">
              <p>Now the blues got a special pattern. We call it A, A, B pattern; that means same, same, different. The first two lines are usually the same and the last one is different.</p>
              <ul>
                <li>
                  <h4 class="scene__letter letter-a1">A</h4>
                  <p
                    :class="{
                      'highlight': trackTime >= 13 && trackTime < 20
                    }"
                  >Mary had a little lamb whose fleece was white as snow.</p>
                </li>
                <li>
                  <h4 class="scene__letter letter-a2">A</h4>
                  <p
                    :class="{
                      'highlight': trackTime >= 24 && trackTime < 30
                    }"
                  >Mary had a little lamb whose fleece was white as snow.</p>
                </li>
                <li>
                  <h4 class="scene__letter letter-b">B</h4>
                  <p
                    :class="{
                      'highlight': trackTime >= 34 && trackTime < 40
                    }"
                  >And everywhere that Mary went, the lamb was sure to go.</p>
                </li>
              </ul>
            </div>
          </div>
          <div
            class="scene scene-4"
            :class="{
              'active': currentScene === 4
            }"
          >
            <div class="scene__background"></div>
            <div class="scene__content">
              <h2 class="scene-4__improvisation">Improvisation</h2>
              <div
                class="scene-4__syllables"
                :class="{
                  'active': trackTime >= 4.5
                }"
              >
                <div class="scene-4__syllable im">im</div>
                <div class="scene-4__syllable dot dot-1"></div>
                <div class="scene-4__syllable pro">pro</div>
                <div class="scene-4__syllable dot dot-2"></div>
                <div class="scene-4__syllable vi">vi</div>
                <div class="scene-4__syllable dot dot-3"></div>
                <div class="scene-4__syllable sa">sa</div>
                <div class="scene-4__syllable dot dot-4"></div>
                <div class="scene-4__syllable tion">tion</div>
              </div>
              <p>That means to improvise. That means you make up as you go along. I don't know. Whatever makes me feel good that day I just sing it. I just throw it on in there you know what I mean. Can you try to improvise with some words?</p>
              <p>See what you can make up because you know, that's the good thing about the blues. Anyway you sing it's all right.</p>
            </div>
          </div>
          <div
            class="scene scene-5"
            :class="{
              'active': currentScene === 5
            }"
          >
            <div class="scene__background"></div>
            <div class="scene__content">
              <p>
                So remember what kind of pattern?<br/>
                A, A, B means same, same, different.
              </p>
              <ul>
                <li class="input-a1">
                  <label for="input-a1">A</label>
                  <input type="text" id="input-a1" v-model="inputVerseA">
                </li>
                <li class="input-a2">
                  <label for="input-a2">A</label>
                  <input type="text" id="input-a2" v-model="inputVerseA">
                </li>
                <li class="input-b">
                  <label for="input-b">B</label>
                  <input type="text" id="input-b" v-model="inputVerseB">
                </li>
              </ul>
              <p>Write your verses and hit Enter when you are done.</p>
            </div>
          </div>
          <div
            class="scene scene-6"
            :class="{
              'active': currentScene === 6
            }"
          >
            <div class="scene__background"></div>
            <div class="scene__content">
              <p>Now hit play and sing your own blues song.</p>
              <ul>
                <li>
                  <h4 class="scene__letter letter-a1">A</h4>
                  <p
                    :class="{
                      'highlight': trackTime > 0 && trackTime < 8
                    }"
                  >{{ verseA }}</p>
                </li>
                <li>
                  <h4 class="scene__letter letter-a2">A</h4>
                  <p
                    :class="{
                      'highlight': trackTime >= 11 && trackTime < 17
                    }"
                  >{{ verseA }}</p>
                </li>
                <li>
                  <h4 class="scene__letter letter-b">B</h4>
                  <p
                    :class="{
                      'highlight': trackTime >= 21 && trackTime < 27
                    }"
                  >{{ verseB }}</p>
                </li>
              </ul>
            </div>
            <button
              class="scene__play button"
              @click="playBlues()"
              v-if="!audioScene6.playing()"
            >Play</button>
            <button
              class="scene__play button"
              @click="stopBlues()"
              v-else
            >Stop</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="orientation-warning"
      v-if="false"
    >
      <h4>
        This interactive is best experienced in landscape orientation.
      </h4>
      <p>
        Please rotate your device.
      </p>
      <div class="orientation-warning__icon"></div>
    </div>
  </div>
</template>

<script>
import Leroy from '@/components/Leroy'
import Raindrop from '@/components/Raindrop'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'app',
  components: {
    Leroy,
    Raindrop
  },
  computed: {
    ...mapState([
      'numScenes',
      'currentScene',
      'beginButton',
      'verseA',
      'verseB',
      'muted',
      'trackTime',
      'audioScene1',
      'audioScene2',
      'audioScene3',
      'audioScene4',
      'audioScene5',
      'audioScene6',
      'isScreenOrientationWarningActive'
    ]),
    nextButtonText () {
      if (
        this.currentScene === 1 ||
        this.currentScene === 2 ||
        this.currentScene === 3 ||
        this.currentScene === 4
      ) {
        return 'Next'
      } else if (this.currentScene === 5) {
        return 'Enter'
      } else {
        return 'End'
      }
    },
    inputVerseA: {
      set (value) {
        this.SET_VERSE_A(value)
      },
      get () {
        return this.verseA
      }
    },
    inputVerseB: {
      set (value) {
        this.SET_VERSE_B(value)
      },
      get () {
        return this.verseB
      }
    }
  },
  methods: {
    ...mapMutations([
      'SET_VERSE_A',
      'SET_VERSE_B',
      'RESET_TRACK_INTERVAL'
    ]),
    ...mapActions([
      'begin',
      'previousScene',
      'nextScene',
      'toggleMute',
      'playBlues',
      'stopBlues',
      'detectScreenOrientation'
    ])
  }
}
</script>

<style lang="scss">

</style>
